/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import Link from '@material-ui/core/Link'
import React, { FC, useState } from 'react'
import moment from 'moment'
import TelegramIcon from '@material-ui/icons/Telegram'
import YouTubeIcon from '@material-ui/icons/YouTube'
import TwitterIcon from '@material-ui/icons/Twitter'
import LinkedInIcon from '@material-ui/icons/LinkedIn'

import { ReactComponent as LogoFooter } from '../../../../assets/logo-footer.svg'
import { useLayoutFooterStyles } from './layout-footer.styles'
import { SupportModal } from './supportModal'
import { Typography, useMediaQuery, useTheme } from '@material-ui/core'
import { useRouter } from 'next/router'
import clsx from 'clsx'
import { Facebook } from '@material-ui/icons'
import { ReactComponent as VkIcon } from 'public/assets/icons/bx_bxl-vk.svg'
import {
  // getServiceURL,
  SERVICES_URL,
  useLocale,
  useTranslation
} from '@plandi/common'

type servicesType = {
  url: string
  subUrl?: string
  subUrlFaq?: string
  title: string
  subTitle?: string
  subTitleFaq?: string
  active?: boolean
}

type documentsType = {
  url: string
  title: string
}

type socialsType = {
  url: string
  class: string
  icon: JSX.Element
}

export const LayoutFooter: FC = () => {
  const url = SERVICES_URL

  const router = useRouter()
  const { data: translate } = useTranslation()
  const locale = useLocale()

  const redirectUrl =
    locale === 'ru'
      ? `${url.blog}/ru` + router.asPath
      : url.blog + router.asPath

  const classes = useLayoutFooterStyles()

  const services = [
    {
      url: locale === 'ru' ? `${url.shop}/ru/models` : `${url.shop}/models`,
      subUrl: locale === 'ru' ? `${url.shop}/ru` : url.shop,
      subUrlFaq:
        locale === 'ru'
          ? `${url.main}/ru` +
            `/questions?question=market&redirect=${redirectUrl}`
          : url.main + `/questions?question=market&redirect=${redirectUrl}`,
      title: translate?.market?.title ?? 'Проектный маркет',
      subTitle:
        locale === 'ru'
          ? 'О сервисе Проектный Маркет'
          : `About ${translate?.market?.title} service` ??
            'О сервисе Проектный Маркет',
      subTitleFaq: `FAQ ${translate?.market?.title}` ?? 'FAQ Проектный Маркет'
    },
    {
      url:
        locale === 'ru' ? `${url.job}/ru/applicants` : `${url.job}/applicants`,
      subUrl: locale === 'ru' ? `${url.job}/ru` : url.job,
      subUrlFaq:
        locale === 'ru'
          ? `${url.main}/ru` + `/questions?question=job&redirect=${redirectUrl}`
          : url.main + `/questions?question=job&redirect=${redirectUrl}`,
      title: translate?.job?.title2 ?? 'Фриланс и Работа',
      subTitle:
        locale === 'ru'
          ? 'О сервисе Фриланс и Работа'
          : `About ${translate?.job.title2} service` ??
            'О сервисе Фриланс и Работа',
      subTitleFaq: `FAQ ${translate?.job?.title2}` ?? 'FAQ Фриланс и Работа'
    },
    {
      url: `https://${
        process.env.NEXT_PUBLIC_NODE_ENV === 'stage' ? 'stage-office' : 'office'
      }.plandi.io${locale === 'ru' ? '/ru' : ''}`,
      subUrl: `https://${
        process.env.NEXT_PUBLIC_NODE_ENV === 'stage' ? 'stage-office' : 'office'
      }.plandi.io${locale === 'ru' ? '/ru' : ''}`,
      subUrlFaq:
        locale === 'ru'
          ? `${url.main}/ru` +
            `/questions?question=office&redirect=${redirectUrl}`
          : url.main + `/questions?question=office&redirect=${redirectUrl}`,
      title: translate?.office.title ?? 'Онлайн офис',
      subTitle:
        locale === 'ru'
          ? 'О сервисе Онлайн Офис'
          : `About ${translate?.office?.title} service` ??
            'О сервисе Онлайн Офис',
      subTitleFaq: `FAQ ${translate?.office?.title}` ?? 'FAQ Онлайн Офис'
    },
    {
      url: locale === 'ru' ? `${url.blog}/ru/articles` : `${url.blog}/articles`,
      title: translate?.blog ?? 'Блог',
      active: true
    }
  ]

  const documents = [
    {
      url: 'https://storage.yandexcloud.net/plandi-storage/storage/%D0%9F%D1%80%D0%B0%D0%B2%D0%B8%D0%BB%D0%B0%20%D0%BC%D0%BE%D0%B4%D0%B5%D1%80%D0%B0%D1%86%D0%B8%D0%B8.pdf',
      title: translate?.main?.footer?.['rules-services'] ?? 'Правила модерации'
    },
    {
      url: 'https://storage.yandexcloud.net/plandi-storage/storage/%D0%9E%20%D0%B7%D0%B0%D1%89%D0%B8%D1%82%D0%B5%20%D0%B0%D0%B2%D1%82%D0%BE%D1%80%D1%81%D0%BA%D0%B8%D1%85%20%D0%BF%D1%80%D0%B0%D0%B2.pdf',
      title:
        translate?.main?.footer?.['about-copyright'] ??
        'О защите авторских прав'
    },
    {
      url: 'https://storage.yandexcloud.net/plandi-storage/storage/%D0%A1%D0%BE%D0%B3%D0%BB%D0%B0%D1%88%D0%B5%D0%BD%D0%B8%D0%B5_%D0%BE%D0%B1_%D0%B8%D1%81%D0%BF%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D0%BD%D0%B8%D0%B8_%D1%81%D0%B0%D0%B9%D1%82%D0%B0_plandi_ru.pdf',
      title:
        translate?.main?.footer?.['site-agreement'] ??
        'Соглашение об использовании сайта plandi.io'
    },
    {
      url: 'https://storage.yandexcloud.net/plandi-storage/storage/%D0%9F%D0%BE%D0%BB%D0%B8%D1%82%D0%B8%D0%BA%D0%B0_%D0%BE%D0%B1%D1%80%D0%B0%D0%B1%D0%BE%D1%82%D0%BA%D0%B8_%D0%BF%D0%B5%D1%80%D1%81%D0%BE%D0%BD%D0%B0%D0%BB%D1%8C%D0%BD%D1%8B%D1%85_%D0%B4%D0%B0%D0%BD%D0%BD%D1%8B%D1%85_%D0%9F%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D1%82%D0%B5%D0%BB%D0%B5%D0%B9.pdf',
      title:
        translate?.main?.footer?.['user-policy'] ??
        'Политика обработки персональных данных Пользователей'
    },
    {
      url: 'https://storage.yandexcloud.net/plandi-storage/storage/%D0%9F%D0%BE%D0%BB%D0%B8%D1%82%D0%B8%D0%BA%D0%B0%20%D0%BA%D0%BE%D0%BD%D1%84%D0%B8%D0%B4%D0%B5%D0%BD%D1%86%D0%B8%D0%B0%D0%BB%D1%8C%D0%BD%D0%BE%D1%81%D1%82%D0%B8.pdf',
      title:
        translate?.main?.footer?.['privacy-policy'] ??
        'Политика конфиденциальности'
    },
    {
      url: 'https://storage.yandexcloud.net/plandi-storage/storage/%D0%90%D0%B3%D0%B5%D0%BD%D1%82%D1%81%D0%BA%D0%BE%D0%B5%20%D1%81%D0%BE%D0%B3%D0%BB%D0%B0%D1%88%D0%B5%D0%BD%D0%B8%D0%B5.pdf',
      title:
        translate?.main?.footer?.['agency-agreement'] ?? 'Агентское соглашение'
    },
    {
      url: 'https://storage.yandexcloud.net/plandi-storage/storage/%D0%9F%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D1%82%D0%B5%D0%BB%D1%8C%D1%81%D0%BA%D0%BE%D0%B5%20%D1%81%D0%BE%D0%B3%D0%BB%D0%B0%D1%88%D0%B5%D0%BD%D0%B8%D0%B5.pdf',
      title:
        translate?.main?.footer?.['user-agreement'] ??
        'Пользовательское соглашение'
    },
    {
      url: 'https://storage.yandexcloud.net/plandi-storage/storage/%D0%9F%D0%BE%D0%BB%D0%BE%D0%B6%D0%B5%D0%BD%D0%B8%D0%B5%20%D0%BE%20%D1%80%D0%B0%D1%81%D1%81%D0%BC%D0%BE%D1%82%D1%80%D0%B5%D0%BD%D0%B8%D0%B8%20%D1%81%D0%BF%D0%BE%D1%80%D0%BE%D0%B2.pdf',
      title:
        translate?.main?.footer?.['dispute-policy'] ??
        'Положение о рассмотрении споров'
    },
    {
      url: 'https://storage.yandexcloud.net/plandi-storage/storage/%D0%9F%D0%BE%D0%BB%D0%BE%D0%B6%D0%B5%D0%BD%D0%B8%D0%B5_%D0%BE_%D0%9A%D0%BE%D0%BC%D0%B8%D1%81%D1%81%D0%B8%D0%B8_%D0%BF%D0%BE_%D1%83%D1%80%D0%B5%D0%B3%D1%83%D0%BB%D0%B8%D1%80%D0%BE%D0%B2%D0%B0%D0%BD%D0%B8%D1%8E_%D1%81%D0%BF%D0%BE%D1%80%D0%BE%D0%B2.pdf',
      title:
        translate?.main?.footer?.['dispute-commission'] ??
        'Положение о Комиссии по урегулированию споров'
    },
    {
      url: 'https://storage.yandexcloud.net/plandi-storage/storage/%D0%BF%D1%80%D0%B0%D0%B2%D0%B8%D0%BB%D0%B0%20%D0%BF%D0%BE%D0%B2%D0%B5%D0%B4%D0%B5%D0%BD%D0%B8%D1%8F%20%D0%BD%D0%B0%20%D1%81%D0%B0%D0%B8%CC%86%D1%82%D0%B5.pdf',
      title: locale === 'en' ? 'Rules of conduct' : 'Правила поведения на сайте'
    }
  ]

  const socials = [
    {
      url: 'https://t.me/joinchat/AAAAAEuYq1OcwjEVhZjN6A',
      class: classes.telegram,
      icon: <TelegramIcon />
    },
    {
      url: 'https://www.youtube.com/channel/UCAIG4a-FPIxW_jU0d3-AM_w?view_as=subscriber',
      class: classes.youtube,
      icon: <YouTubeIcon />
    },
    {
      url: 'https://twitter.com/plan_di',
      class: classes.twitter,
      icon: <TwitterIcon />
    },
    {
      url: 'https://www.linkedin.com/in/plan-di',
      class: classes.linkedin,
      icon: <LinkedInIcon />
    },
    {
      url: 'https://www.facebook.com/plandi.ru.official?mibextid=LQQJ4d',
      class: classes.facebook,
      icon: <Facebook />
    },
    {
      url: 'https://vk.com/plandiruofficial',
      class: classes.vkontakte,
      icon: <VkIcon />
    }
  ]

  const [open, setOpen] = useState(false)

  const activeFooterLink = router.asPath.includes('documents-and-agreements')
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down(768))

  const handleClick = () => {
    setOpen((prev) => !prev)
  }

  return (
    <div className={classes.root}>
      <div className={classes.blockSocial}>
        <LogoFooter className={classes.logo} />
        {!isMobile && (
          <div className={classes.icons}>
            <div className={classes.iconsBlock}>
              {socials.map((social: socialsType) => (
                <Link
                  key={social.url}
                  href={social.url}
                  target="_blank"
                  className={clsx(classes.link, social.class)}
                >
                  {social.icon}
                </Link>
              ))}
            </div>
            <Typography className={classes.link} style={{ marginTop: 16 }}>
              {translate?.main?.footer?.['all-rights']
                ?.replace('2022', moment().format('YYYY'))
                .replace('ru', locale === 'ru' ? 'ru' : 'io')}
            </Typography>
          </div>
        )}
      </div>
      <div className={classes.servicesBlock}>
        {services.map((service: servicesType) => (
          <div key={service.title} className={classes.services}>
            <Link
              href={service.url}
              className={clsx(classes.linkService, {
                [classes.activeLink]: service.active
              })}
            >
              {service.title}
            </Link>
            <Link href={service.subUrl} className={classes.linkSubService}>
              {service.subTitle}
            </Link>
            <Link
              href={service.subUrlFaq}
              className={classes.linkSubServiceFaq}
            >
              {service.subTitleFaq}
            </Link>
          </div>
        ))}
      </div>
      {isMobile && (
        <div className={classes.iconsBlock}>
          {socials.map((social: socialsType) => (
            <Link
              key={social.url}
              href={social.url}
              target="_blank"
              className={clsx(classes.link, social.class)}
            >
              {social.icon}
            </Link>
          ))}
        </div>
      )}
      <div className={classes.documentsBlock}>
        <div className={classes.documents}>
          <Link
            href={
              locale === 'ru'
                ? `${url.main}/ru/documents-and-agreements`
                : `${url.main}/documents-and-agreements`
            }
            className={classes.linkPage}
            style={{ color: activeFooterLink ? '#fff' : '' }}
          >
            {translate?.main?.footer?.documents ?? 'Документы и соглашения'}
          </Link>
          {documents.slice(0, 5).map((document: documentsType) => (
            <Link
              key={document.url}
              href={document.url}
              target="_blank"
              className={classes.linkDocument}
            >
              {document.title}
            </Link>
          ))}
        </div>
        <div
          className={classes.documents}
          style={{ marginTop: isMobile ? 0 : 5 }}
        >
          {documents.slice(5).map((document: documentsType) => (
            <Link
              key={document.url}
              href={document.url}
              target="_blank"
              className={classes.linkDocument}
            >
              {document.title}
            </Link>
          ))}
          <button
            type="button"
            className={classes.linkBtn}
            onClick={handleClick}
          >
            {translate?.main?.footer?.['technical-support']?.[
              'support'
            ].replace('ru', locale === 'ru' ? 'ru' : 'io') ??
              'Техподдержка: info@plandi.ru'}
          </button>
        </div>
      </div>

      <SupportModal open={open} handleClick={handleClick} />
    </div>
  )
}
